module.exports = __webpack_public_path__ + "media/images/password-recovery-background-5379e901dac1a691b1c77bd09dd8af40.jpg";